import { InjectionToken } from '@angular/core';

export enum PageTitlePositioning {
  AppendPageTitle = 0,
  PrependPageTitle = 10,
}

export interface MetaSettings {
  title?: string;
  description?: string;
  override?: boolean;
  [key: string]: string | boolean | undefined;
}

export interface MetaConfig {
  pageTitlePositioning?: PageTitlePositioning;
  pageTitleSeparator?: string;
  applicationName?: string;
  defaults?: MetaSettings;
}

export const META_CONFIG = new InjectionToken<MetaConfig>('META_CONFIG');

export abstract class MetaLoader {
  abstract getSettings(): MetaConfig;
}

export class MetaStaticLoader implements MetaLoader {
  constructor(private readonly settings: MetaConfig = {}) {}

  getSettings(): MetaConfig {
    return this.settings;
  }
}
